import { useEffect, useState } from 'react';

import AdminLayout from '../../Layouts/AdminLayout';

import BlockContent from '../../Components/Manager/BlockContent';
import { useNotification } from '../../Contexts/NotificationContext';

function App() {
    const { setNotification } = useNotification();
    const [types, setTypes] = useState([]);
    const [categories, setCategories] = useState([]);
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const fetchGroups = async () => {
        try {
            const groupsResponse = await fetch(`${baseUrl}/manager/grupos/`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });

            if (groupsResponse.ok) {
                const groupsData = await groupsResponse.json();
                setGroups(groupsData.grupos || []);
            } else {
                throw new Error('Erro ao buscar os grupos.');
            }
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        }
    };

    const fetchCategories = async () => {
        try {
            const categoriesResponse = await fetch(`${baseUrl}/manager/categorias/`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });

            if (categoriesResponse.ok) {
                const categoriesData = await categoriesResponse.json();
                setCategories(categoriesData.categorias || []);
            } else {
                throw new Error('Erro ao buscar as categorias.');
            }
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        }
    };

    const fetchTypes = async () => {
        try {
            const typesResponse = await fetch(`${baseUrl}/manager/tipos/`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });

            if (typesResponse.ok) {
                const typesData = await typesResponse.json();
                setTypes(typesData.tipos || []);
            } else {
                throw new Error('Erro ao buscar os tipos.');
            }
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        }
    };

    useEffect(() => {
        setLoading(true);
        Promise.all([fetchCategories(), fetchGroups(), fetchTypes()])
            .finally(() => setLoading(false));
    }, []);

    const contentTypes = {
        nome: ['Tipos', 'tipo'],
        route: 'tipos',
        imagens: false,
        editavel: true,
        conteudo: types,
        onUpdate: fetchTypes,
    };

    const contentCategories = {
        nome: ['Categorias', 'categoria'],
        route: 'categorias',
        imagens: false,
        editavel: true,
        conteudo: categories,
        onUpdate: fetchCategories,
    };

    const contentGroups = {
        nome: ['Grupos de materiais', 'grupo'],
        route: 'grupos',
        imagens: false,
        editavel: true,
        conteudo: groups,
        onUpdate: fetchGroups,
    };

    return (
        <AdminLayout>
            <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10">
                <div className="mt-4 grid grid-cols-12 gap-4 md:mt-4 md:gap-6 2xl:mt-7.5 2xl:gap-7.5">
                    <div className="col-span-12">
                        <BlockContent content={contentTypes} loading={loading} />
                        <BlockContent content={contentCategories} loading={loading} />
                        <BlockContent content={contentGroups} loading={loading} />
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
}

export default App;
